module.exports = __webpack_public_path__ + "static/media/wrong.acc2e6af.png";